import axios from '../axios';

const setPolicy = async (data) => {
  await axios.post("api/admin/settings/policy", data);
}
    
export default setPolicy;
